export const ThemePrimaryColor = '#cddc39';
export const ThemeAccentColor = '#f1c40f';
export const BlackColor = '#000';
export const WhiteColor = '#fff';
export const ShadowColor = 'lightgrey';
